export enum InvoiceWasteBy {
  Net = 0,
  Kg = 1,
  Cubic = 2,
}

export const InvoiceWasteByOptions = [
  {
    value: InvoiceWasteBy.Net,
    label: 'service.invoiceWasteByNet',
  },
  {
    value: InvoiceWasteBy.Kg,
    label: 'service.invoiceWasteByKg',
  },
  {
    value: InvoiceWasteBy.Cubic,
    label: 'service.invoiceWasteByCubicMeter',
  }
];
